import { Component, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IonicPage, LoadingController, NavController, NavParams, ViewController } from 'ionic-angular';
import { Util } from '../../app/util';

/**
 * Generated class for the CambiaSquadraPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cambia-squadra',
  templateUrl: 'cambia-squadra.html',
})
export class CambiaSquadraPage extends Util {
  myInput;
  shouldShowCancel = true;
  squadre = [];
  squadreaux = [];
  campionatoid: any;
  squadra_attuale: any;
  utente: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, injector: Injector, loading: LoadingController, public translate: TranslateService, public navParam: NavParams, public viewcontroller: ViewController) {
    super(injector, loading);
    // this.squadre = this.navParam.get('squadre');
    this.squadreaux = this.navParam.get('squadre');
    this.squadra_attuale = this.navParam.get('squadra_attuale');
    this.utente = this.navParam.get('utente');
    // this.campionatoid = this.navParam.get('campionatoid');
    this.squadre = this.navParams.get('squadre');
    // console.log('squadrxexxx', this.squadra_attuale);
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad SelectSquadraPage');


  }

  dismiss() {
    this.viewcontroller.dismiss();
  }

  getItems(ev: any) {
    // Reset items back to all of the items
    // this.initializeItems();
    this.squadre = this.squadreaux;
    // set val to the value of the searchbar
    const val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.squadre = this.squadre.filter((item) => {
        return (item.nome.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }
  onCancel($event) {

  }

  cambia(s) {
    const alert = this.alertCtrl.create({
      title: 'Cambio Squadra',
      subTitle: 'Sei sicuro di voler cambiare la squadra da "' + this.squadra_attuale.nome + '" a "' + s.nome + '"?',
      // cssClass: 'alertcambiasquadra',
      cssClass: this.etheme.theme_selected,
      buttons: [{
        text: 'Annulla',
        handler: data => {
          // console.log('Cancel clicked');
        }
      },
      {
        text: 'SI CONFERMO',
        handler: data => {
          // console.log('Saved clicked');
            this.viewcontroller.dismiss(s);
        }
      }]
    });
    alert.present();
 
  }

  // iscriviti(s) {
  //   const alert = this.alertCtrl.create({
  //     title: 'Selezione direzione',
  //     subTitle: 'Hai selezionato la direzione "' + s.nome + '", confermi questa scelta?',
  //     cssClass: 'alertdirezione',
  //     buttons: [{
  //       text: 'Annulla',
  //       handler: data => {
  //         // console.log('Cancel clicked');
  //       }
  //     },
  //     {
  //       text: 'SI CONFERMO',
  //       handler: data => {
  //         // console.log('Saved clicked');
  //         this.viewcontroller.dismiss(s);
  //       }
  //     }]
  //   });
  //   alert.present();


  // }
}



// WEBPACK FOOTER //
// ./src/pages/cambia-squadra/cambia-squadra.ts